import $ from 'jquery';
import { closeModal } from '@/function/function.js';
import store_patient from '@/store/mods/patients/patient';

export default {
    name: 'liste-patient',
    components: {},
    props: [],
    data() {
        return {
            selectedPatient: null,

            fields: [
                { key: 'index', label: 'N°' },
                { key: 'patient_code', label: 'Numéro de dossier' }, 
                { key: 'patient_nom', label: 'Patient' }, 'sexe', 
                { key: 'age', label: 'Âge' },  'patient_telephone',
                'assurance', { key: 'actions', label: 'Actions' }
            ],

            liste_patients: [],
            is_loading: true,
            is_empty: false,
            is_error: false,
            curr_page: 1,
            per_page: -1,
            total_pages: 0,
            filter: '',
            last_page: 0,
            goto_page: 1,
            search_term: '',
            from_index: 1,
        }
    },

    watch: {
        filter() {
            if (this.filter == '') {
                this.search_term = ''
                this.getListePatients()
            }
        }
    },

    computed: {
        user_role() {
            return this.$store.getters['activeRole'].nom;
        },
    },

    mounted() {
        this.getListePatients() 
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);
    },

    methods: {
        getListePatients() {
            this.is_loading = true
            const data = {
                with_consultation: false,
                search_term: this.search_term,
                page: this.goto_page,
            }
            store_patient.getListeTousPatients(data).then((response) => {
                this.liste_patients = response.data
                this.last_page = response.last_page
                this.total_pages = response.last_page
                this.from_index = response.from


                if (this.liste_patients.length === 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }

                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        modalDeletePatient: function(patient) {
            this.selectedPatient = patient
        },

        deletePatient: function(id) {

            this.$store.dispatch("deletePatient", id).then(() => {
                this.$refs.closeBtn.click();
                this.deletionSuccess()
            })
        },

        close: function() {
            $('#exampleModal').modal('show')
        },

        deletionSuccess: function() {
            this.$toasted.show('Le compte du patient a été supprimé avec succès', {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success'
            })
        },

        /**
         * Close Modal
         * @param {*} selector 
         */
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        previousPage() {
            if (this.curr_page > 1) {
                this.curr_page--;
                this.goto_page = this.curr_page
                this.getListePatients()
            }
        },

        nextPage() {
            if (this.curr_page < this.total_pages) {
                this.curr_page++;
                this.goto_page = this.curr_page
                this.getListePatients()
            }
        },

        gotoPage(page) {
            if (page !== this.curr_page) {
                this.curr_page = page;
                this.goto_page = this.curr_page
                this.getListePatients()
            }
        },

        searchPatient() {
            this.search_term = this.filter

            this.getListePatients()
        }
    }
}